<template>
  <div
    :class="{
      apothekenfinder: true,
      fadeLoading: true,
      loading: dataStore.loading.apothekenfinder,
    }"
  >
    <div :class="dataStore?.otherInfo?.apothekenfinder?.type">
      <div v-if="headline || bodytext" class="mb-5 pb-2">
        <h1 v-if="headline" v-html="headline"></h1>
        <div v-if="bodytext" v-html="bodytext"></div>
      </div>
      <Form :defaultType="type" :resultsPerPage="resultsPerPage"/>
      <section class="results" :aria-label="formLabel + ' Suchresultaten'">
        <Pager :resultsPerPage="resultsPerPage" :withStatusMessage="true" />
        <ResultList  :resultsPerPage="resultsPerPage" />
        <Pager :resultsPerPage="resultsPerPage"/>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useDataStore } from "@/store/";
import Pager from "@/components/Pager";
import ResultList from "@/components/Apothekenfinder/ResultList";
import Form from "@/components/Apothekenfinder/Form";

const dataStore = useDataStore();
const defaultTypeUp = typeof defaultType !== 'undefined' ? defaultType : "apotheken";
const type = ref(defaultTypeUp);
const { otherInfo } = storeToRefs(dataStore);
const headline = ref("");
const bodytext = ref("");
const resultsPerPage = 50;
const formLabel = ref("");

watch(
  otherInfo,
  (newVal, oldVal) => {
    type.value = newVal?.apothekenfinder?.type;
      formLabel.value =  dataStore.otherInfo.apothekenfinder.type == "apotheken"
    ? "Apothekensuche"
    : "Notdienstsuche";
    setTexts();
  },
  { deep: true }
);

const setTexts = () => {
  if (type.value == "apotheken") {
    headline.value = typeof headlineApotheken !== "undefined" ? headlineApotheken : "";
    bodytext.value = typeof textApotheken !== "undefined" ? textApotheken : "";
  } else {
    headline.value = typeof headlineNotdienst !== "undefined" ? headlineNotdienst : "";
    bodytext.value = typeof textNotdienst !== "undefined" ? textNotdienst : "";
  }
};
</script>
